import Banner from '@structure/Resources/Banner';
import GalleryBannerConfig from '@structure/Configuration/GalleryBannerConfig';

export default class GalleryBanner {
  constructor(
    protected configuration: GalleryBannerConfig,
    protected banner: Banner
  ) {
    //
  }

  public caption(): string {
    return this.config().get('caption');
  }

  public basename(): string {
    return this.resource().basename();
  }

  public config(): GalleryBannerConfig {
    return this.configuration;
  }

  public resource(): Banner {
    return this.banner;
  }
}
